import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleXmark,faCircleCheck} from "@fortawesome/free-solid-svg-icons";
import {Button} from "react-bootstrap";
import {Link, useParams} from "react-router-dom";

export default function TimelineResult (props) {

    let { studentnumber } = useParams();

    console.log(props.data)
    const score = props.data.score;
    const faIcon = score > 55 ? faCircleCheck : faCircleXmark;
    return (
        <div style={{ color: "#7a7a7a"}} className="text-center d-flex flex-column">
            <h1>{score}<span>/100</span></h1>
            <FontAwesomeIcon style={{fontSize: "50px"}} icon={faIcon} /><br/>
            <Link to={"/student/"+studentnumber+"/submission/"+props.data.id}><Button  variant="secondary">View report</Button></Link>
        </div>
    )
}